module.exports = __webpack_public_path__ + "img/extra-luggage.94fc95ff.svg";